import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuMobileService } from './menu-mobile.service';
import { NavigationStart, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'menu-category-mobile',
  templateUrl: './menu-category-mobile.component.html',
  styleUrl: './menu-category-mobile.component.scss',
  standalone: false,
})
export class MenuCategoryMobileComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription();
  status$ = this.menuService.status();

  constructor(
    private router: Router,
    private menuService: MenuMobileService,
  ) {}

  ngOnInit(): void {
    this.listnerRoutes();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  listnerRoutes() {
    this.subscriptions.add(
      this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
        this.menuService.statusAsValue() && this.menuService.close();
      }),
    );
  }
}
